<template>
    <el-dialog v-model="view" title="权限设置" width="45%" :before-close="handleClose" top="5vh">

        <ul class="TTL-trees" id="table-managerauth-obj">
            <li v-for="(it,i) in menus" :key="i" :class="!it.isshow ? '' : 'closetree'" :ref="'tree'+i">
                <div class="TTL-trees-in">
                <i class="showicon" @click="target(it)"></i>
                <div class="TTL-checkbox"><el-checkbox v-model="it.isselect" :indeterminate.sync="it.isselectAll" @click.stop.prevent="selectLabel(it,i)" /></div>
                <span>{{it.name}}<i v-if="it.isfree">（收费功能）</i></span>
                </div>
                <ul :class="it.level==1 ? 'TTL-trees TTL-trees-inline' : 'TTL-trees'" v-if="it.children.length > 0">
                    <li v-for="(iit,ii) in it.children" :key="ii" :class="!iit.isshow ? '' : 'closetree'" :ref="'tree'+i+'-'+ii">
                        <div class="TTL-trees-in">
                        <i class="showicon" @click="target(iit)"></i>
                        <div class="TTL-checkbox"><el-checkbox v-model="iit.isselect" :indeterminate.sync="iit.isselectAll" @click.stop.prevent="selectLabel(iit,i+'-'+ii)" /></div>
                        <span>{{iit.name}}<i v-if="iit.isfree">（收费功能）</i></span>
                        </div>
                        <ul :class="iit.level==1 ? 'TTL-trees TTL-trees-inline' : 'TTL-trees'" v-if="iit.children.length > 0">
                            <li v-for="(iiit,iii) in iit.children" :key="iii" :class="!iiit.isshow ? '' : 'closetree' " :ref="'tree'+i+'-'+ii+'-'+iii">
                                <div class="TTL-trees-in">
                                <i class="showicon nochild" @click="target(iiit)"></i>
                                <div class="TTL-checkbox"><el-checkbox v-model="iiit.isselect" :indeterminate.sync="iiit.isselectAll" @click.stop.prevent="selectLabel(iiit,i+'-'+ii+'-'+iii)"/></div>
                                <span>{{iiit.name}}<i v-if="iit.isfree">（收费功能）</i></span>
                                </div>
                                <ul class="TTL-trees TTL-trees-inline" v-if="iiit.children.length > 0">
                                    <li v-for="(iiiit,iiii) in iiit.children" :key="iiii" :class="!iiiit.isshow ? '' : 'closetree' " :ref="'tree'+i+'-'+ii+'-'+iii+'-'+iiii">
                                        <div class="TTL-trees-in">
                                        <i :class="iiiit.children.length > 0 ? 'showicon' : 'showicon nochild'" @click="target(iiiit)"></i>
                                        <div class="TTL-checkbox"><el-checkbox v-model="iiiit.isselect" :indeterminate.sync="iiiit.isselectAll" @click.stop.prevent="selectLabel(iiiit,i+'-'+ii+'-'+iii+'-'+iiii)"/></div>
                                        <span>{{iiiit.name}}<i v-if="iiiit.isfree">（收费功能）</i></span>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>

        <div class="TTL-page-box top40">
            <div class="TTL-page-box-in">
                <div class="TTL-page TTL-page-right">
                    <div class="TTL-button">
                    <el-button type="del" @click="handleClose">取消</el-button>
                    <el-button @click="SubmitAuth">提交</el-button>
                    </div>
                </div>
            </div>
        </div>

    </el-dialog>
</template>

<script>
import INTERFACE_MODEL_MANAGER from '@/Interface/manager/manager';
export default {
    props:['value','id'],
    components:{},
    data() {
        return {
            view:false,
            roleparam: {
                id:'',
                data:'',
            },
            selectids:[],
            menus:[
                {id:0,name:'全选',level:0,isselect:false,children:[
                    {id:1,name:'宠物管理',level:1,isselect:true,children:[]},
                    {id:2,name:'宠物记录',level:1,isselect:false,children:[]},
                    {id:3,name:'会员管理',level:1,isselect:false,children:[
                        {id:4,name:'查看',level:3,isselect:false,children:[]},
                        {id:5,name:'编辑',level:3,isselect:false,children:[]},
                        {id:6,name:'删除',level:3,isselect:false,children:[]},
                    ]},
                ]}
            ],

        }
    },
    mounted() {
        
    },
    watch: {
        value(val) {
            if(!val) return false;
            this.view=true;
            this.roleparam.id=this.id;
            this.GetGroupAuth(this.id);  //获取店铺权限、系统权限信息
        }
    },
    methods: {


        /** 获取角色权限信息 **/
        GetGroupAuth(id) {
            this.menus=[];
            INTERFACE_MODEL_MANAGER.GET_GROUP_AUTH({id:id,level:localStorage.getItem('level')}).then((res) => {
                 if(res.status > 0) return false;
                 this.menus=res.data;
                 console.log(res.data);
                 this.resetLable(this.menus); //刷新菜单树样式  
            });
        },


        /** 关闭窗口 **/
        handleClose() {
            this.view=false;
            this.$emit('AuthRollback');
        },


        /** 提交已选择的权限 **/
        SubmitAuth() {
            this.selectids=[];
            this.GetSelectIds();
            if(this.selectids.length==0) {this.$notice({title:'错误提示',message:'请至少选择一个权限',type:'warning'});return false;}
            this.roleparam.data=JSON.stringify(this.selectids);

            INTERFACE_MODEL_MANAGER.UPDATE_GROUP_AUTH(this.roleparam).then((res) => {
                 if(res.status > 0) return false;
                 this.handleClose();
            });
        },


        ///////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////
        //点击操作


        /** 权限子集收缩、展开 **/
        target(item) {
            item.isshow ? item.isshow=false : item.isshow=true;
        },


        /** 点击选择label **/
        selectLabel(item,treeindex) {
            item.isselectAll=false; //关闭全部选择开关
            item.isselect && item.isselect==true ? item.isselect=false :  item.isselect=true;
            
            //向下处理数据
            this.changeChildLabel(item.children,item.isselect);
            //线上处理数据
            this.changeParentLable(treeindex);
        },


        /** 向上处理数据 **/
        changeParentLable(treeindex) {
            if(treeindex==0) return false; //一级菜单，不往下执行
            treeindex=treeindex.split('-');
            var nums=treeindex.length-1;
            if(nums==0) return '';

            var obj;
            var childisselect=0;
            nums-=1;
            for(var i=0;i < treeindex.length;i++) {
                if(nums < 0) return false;
                obj=this.GetTreeObj(treeindex,nums,this.menus); //获取父级对象
                obj.isselect=false;
                obj.isselectAll=false;
                childisselect=this.checkchildisselect(obj.children);
                if(childisselect==1) {obj.isselect=true;obj.isselectAll=false;} //全部选中
                if(childisselect==2) {obj.isselect=true;obj.isselectAll=true;} //部分选中
                nums--;
            }
        },


        /** 递归获取父级对象信息 **/
        GetTreeObj(treeindex,nums,obj) {
            var obji;
            for(var i=0;i < treeindex.length;i++) {
                if(i > nums) return obj;
                obji=treeindex[i];
                i==0 ? obj=obj[obji] : obj=obj.children[obji];
            }
            return obj;
        },


        /** 向下处理子集、孙子集数据 **/
        changeChildLabel(data,isselect) {
            var obj;
            var children;
            for(var i=0;i < data.length;i++) {
                obj=data[i];
                children=obj.children;
                obj.isselect=isselect;
                obj.isselectAll=false;
                if(children.length > 0) this.changeChildLabel(children,isselect);
            }
        },


        /** 开始加载数据修正勾选菜单（权限树初始化操作） **/
        resetLable(data) {
            var obj;
            var children;
            var childisselect=0;
            if(data.length > 0) {
                for(var i=0;i < data.length;i++) {
                    obj=data[i];
                    children=obj.children;
                    //有子集的执行子集操作
                    if(children.length > 0) {
                        obj.isselect=false;
                        obj.isselectAll=false;
                        childisselect=this.checkchildisselect(children);
                        if(childisselect==1) {obj.isselect=true;obj.isselectAll=false;} //全部选中
                        if(childisselect==2) {obj.isselect=true;obj.isselectAll=true;} //部分选中
                        this.resetLable(children); //下一级进行处理
                    }
                }
            }
        },

        
        /** 检测下面的子集选项（权限树初始化操作） **/
        checkchildisselect(data) {
            var isselectAll=0;
            var datainfo;
            for(var i=0;i < data.length;i++) {
                datainfo=data[i];
                if(datainfo.isselectAll) return 2;                     //有一个子集为部分选择时直接返回部分选择
                if(i > 0 && datainfo.isselect!=isselectAll) return 2;  //部分选中
                datainfo.isselect ? isselectAll=1 : isselectAll=0;
            }
            return isselectAll;
        },


        /** 获取已选中的id信息 **/
        GetSelectIds() {
            this.GetSelectIdsData(this.menus);
        },

        /** 获取已选中的id信息操作 **/
        GetSelectIdsData(obj) {
            var objinfo;
            for(var i=0;i<obj.length;i++) {
                objinfo=obj[i];
                if(objinfo.isselect && objinfo.id > 0) this.selectids.push(objinfo.id);
                if(objinfo.children.length > 0) this.GetSelectIdsData(objinfo.children);
            }
        },

        //点击操作
        ///////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////

    },
}
</script>
<style scoped>
.TTL-trees {display: inline-block;width:calc(100% - 40px);padding:0 20px 0 20px;}
.TTL-trees li {font-size:13px;list-style:none;display:inline-block;margin-right:30px;width:calc(100% - 30px);width:100%;letter-spacing: 1px;cursor: pointer;transition:.5s all;}
.TTL-trees li .TTL-trees-in {height: 40px;display: inline-flex;align-items: center;}
.TTL-trees li .TTL-trees-in .showicon {width:20px;height:20px;margin-right:10px;background-image: url(@/assets/icon/xiala.png);background-repeat: no-repeat;background-size: 10px;background-position: center;transition:.5s all;}
.TTL-trees li .TTL-trees-in .nochild {background-image:none !important;}
.TTL-trees-inline {padding:0 20px 0 20px;}
.TTL-trees-inline li {width:auto;}
.TTL-trees li .TTL-trees-in span {padding-left:10px;color:#333333;}
.TTL-trees li .TTL-trees-in span i {font-style: normal;font-size: 12px;color: #e32626;}
::v-deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner::before) {top:6px;height:5px;}

.closetree {height:40px;overflow: hidden;}
.closetree .TTL-trees-in i {transform: rotate(180deg);}
</style>